import { Box, Typography } from '@mui/material'
import { PageOuterContainer } from '../../root-components/layouts/page-outer-container'
import { PageTitle } from '../presentation-components/display-elements-components/page-title'
import { useContext, useEffect, useState } from 'react'
import { UserDetailsContext } from '../../context/user-details/user-details'
import { Link } from 'react-router-dom'
import { CustomThemeContext } from '../../context/theme/custom-theme-context'



export const NotFoundPage = () => {
  const userDetailsContext = useContext(UserDetailsContext)
  const customThemeContext = useContext(CustomThemeContext)
  const [isLoggedIn, setIsLoggedIn] = useState(false)



  useEffect(() => {
    setIsLoggedIn(!!userDetailsContext.userDetails)
  }, [])

  return (
    <PageOuterContainer>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', mt: 4 }}>
        <img
          src={customThemeContext.logoUrl}
          alt="GAIA logo"
          height="80"
          style={{ marginBottom: 32 }}
        />
        <PageTitle title='Page Not Found' />
        <Typography sx={{ mt: 2 }}>Sorry, we cannot find the page you are looking for.</Typography>
        {isLoggedIn && <Typography component={Link} to='/dashboard' sx={{ color: 'primary.main' }}>Click here to go back to the home page</Typography>}
        {!isLoggedIn && <Typography component={Link} to='/login' sx={{ color: 'primary.main' }}>Click here to sign in</Typography>}
      </Box>
    </PageOuterContainer>
  )
}